export enum Departments {
  FRESH = 'fresh',
  FROZEN = 'frozen'
}

export enum CollectionView {
  LIST = 'list',
  GRID = 'grid'
}
